import { ListingType, PROPERTY_GRID_SUBJECT_PROPERTY, syntaxFNMA } from '@aloft/toolkit-shared';
import { Flex, Icon, theme } from '@aloft/toolkit-sui';

import { Control, useWatch } from 'react-hook-form';

import { getColorForStatusOrSubject } from '../../../utils/getColorForStatusOrSubject.ts';
import { CraftsmanPropertyHeader } from '../../CraftsmanPropertyHeader/CraftsmanPropertyHeader.tsx';
import { ValuationTablePropertyHeaderColorBand } from '../../CraftsmanPropertyHeader/internal/ValuationTablePropertyHeaderColorBand.tsx';
import { PropertyGridForm, PropertyGridType } from '../types.ts';
import { getDataSourceDisplayInfo } from '../utils.ts';

type HeaderPropertyGridSectionProps = {
  columnIndex: number;
  gridType: PropertyGridType;
  control: Control<PropertyGridForm>;
  dataSourceDrawerEnabled: boolean;
  listingType?: ListingType;
};

export const HeaderPropertyGridSection = ({
  columnIndex,
  gridType,
  control,
  dataSourceDrawerEnabled,
  listingType,
}: HeaderPropertyGridSectionProps) => {
  const columnData = useWatch({ control, name: `columns.${columnIndex}` });

  const { propertyData, type, propertyId } = columnData ?? {};

  const transaction = propertyData?.editableData?.transaction;

  if (!propertyData || (type === 'property' && !transaction)) return null;

  const isSubject = propertyId === PROPERTY_GRID_SUBJECT_PROPERTY;
  let propertyStatus:
    | syntaxFNMA.UadListingStatus
    | syntaxFNMA.RentalListingStatus
    | 'Off-Market'
    | 'Subject' = 'Subject';
  if (!isSubject) {
    propertyStatus =
      listingType === 'rentalListing'
        ? (transaction?.rentalListingStatus ?? 'Off-Market')
        : (transaction?.status ?? 'Off-Market');
  }
  const color = getColorForStatusOrSubject(propertyStatus);
  const hideActions = gridType === 'SensitivityGrid';

  if (type === 'property') {
    return (
      <Flex
        flexDirection="column"
        position="sticky"
        top="0"
        zIndex={theme.zIndices.sticky}
        __dangerDoNotUseSx={{ borderTop: `1px solid ${theme.colors.strokeDefault}` }}
      >
        <CraftsmanPropertyHeader
          propertyId={propertyId}
          gridType={gridType}
          showDataSourceDrawerToggler={dataSourceDrawerEnabled}
          listingType={listingType}
          hideActions={hideActions}
        />
      </Flex>
    );
  }

  const { icon, text } = getDataSourceDisplayInfo(type, propertyData);

  return (
    <Flex
      flexDirection="column"
      position="sticky"
      top="0"
      zIndex={theme.zIndices.sticky}
      alignItems="center"
      __dangerDoNotUseSx={{
        borderTop: `1px solid ${theme.colors.strokeDefault}`,
        color: theme.colors.buttonDefault,
      }}
    >
      <Flex flexDirection="column" width="100%" height="115px" backgroundColor="surface1">
        <Flex flexDirection="column" alignItems="center" justifyContent="center" flexGrow={1}>
          <Icon size="xl" icon={icon} color="buttonDefault" />
          {text}
        </Flex>
        <ValuationTablePropertyHeaderColorBand color={color} />
      </Flex>
    </Flex>
  );
};
